import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { setPageMeta } from "@/lib/api";
import { Logo } from "@/components/Navbar";
import { Splatter } from "@/components/Splatter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { setPageMeta("Créer un compte — Tenay Ain-Pression"); }, []);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form);
      navigate("/compte");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center justify-center px-4 py-16">
      <Splatter />
      <div className="relative w-full max-w-md rounded-2xl border border-[#222] bg-[#0A0A0A]/90 backdrop-blur-xl p-8">
        <div className="text-center"><Logo className="text-2xl" /></div>
        <h1 className="mt-6 font-heading text-2xl font-bold text-center">Créer un compte</h1>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          <div><Label>Nom complet</Label><Input data-testid="register-name" value={form.name} onChange={set("name")} className="bg-black border-white/15 mt-1" required /></div>
          <div><Label>E-mail</Label><Input data-testid="register-email" type="email" value={form.email} onChange={set("email")} className="bg-black border-white/15 mt-1" required /></div>
          <div><Label>Téléphone (optionnel)</Label><Input data-testid="register-phone" value={form.phone} onChange={set("phone")} className="bg-black border-white/15 mt-1" /></div>
          <div><Label>Mot de passe</Label><Input data-testid="register-password" type="password" value={form.password} onChange={set("password")} className="bg-black border-white/15 mt-1" required minLength={6} /></div>
          {error && <p data-testid="register-error" className="text-sm text-red-400">{error}</p>}
          <Button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full rounded-full py-6 font-bold">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Créer mon compte"}
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-gray-400">Déjà inscrit ? <Link to="/connexion" className="text-[#E6007E] font-bold">Se connecter</Link></p>
      </div>
    </div>
  );
}
